export default __webpack_public_path__ + "static/media/ic_change_option.e9238c20.svg";